export default {
  2: {
    text: "Suchen Sie einen …",
    type: "checkbox",
    options: [
      {
        value: "Zahnarzt",
      },
      {
        value: "Kieferorthopäden",
      },
      {
        value: "Weiß nicht",
      },
    ],
    info: "Sollten Sie betreffend Ihrer Beschwerden schon genau wissen ob Sie einen Zahnarzt oder Kieferorthopäden benötigen, dann wählen Sie bitte eine dieser Beiden aus. Kieferorthopäden behandeln oftmals nicht alle Zahnprobleme.",
  },
  16: {
    text: "Wann waren Sie zuletzt bei der Zahnvorsorge?",
    type: "date",
    prefix: "Mein letzter Vorsorgetermin:",
  },
  17: {
    text: "Viele Menschen haben Angst vor einem Zahnarztbesuch. Trifft dies auch auf Sie zu?",
    type: "buttons",
    info: "Den Zahnärzten liegt viel daran, dass Sie sich bei einem Zahnarztbesuch wohlfühlen. Sie gehen daher besonders auf Patienten ein, die Angst vor einem Zahnarzttermin haben.",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
  },
};
